<template>
    <div class="block-editor openai-web-search">
        <section v-if="!channel">
            <a-result status="warning" :title="$t('chatbotv2.openaiWebSearchNoConnection')">
                <template #extra>
                    <div class="d-flex align-items-center justify-content-center">
                        <SupsisButton primary ghost @click="gotoOpenai">{{ $t("chatbotv2.openaiWebSearchConnect") }}</SupsisButton>
                    </div>
                </template>
            </a-result>
        </section>
        <template v-else>
            <section class="active-connection">
                <div data-small="true" class="logos">
                    <div class="logo1">
                        <img class="custom-block-logo" src="/static/img/supsis-logo2.png" />
                    </div>
                    <span class="material-icons"> add </span>
                    <div class="logo2">
                        <img class="" src="/static/img/openai.png" />
                    </div>
                </div>
                <div class="active-connection-text">
                    <div><span>{{ $t("chatbotv2.openaiWebSearchConnected") }}</span> <b>OpenAI</b></div>
                </div>
            </section>
            <div class="editor-row">
                <div class="editor-row-title">{{ $t("chatbotv2.openaiWebSearchQuery") }}</div>
                <TiptapEditor
                    :placeholder="$t('chatbotv2.openaiWebSearchQueryPh')"
                    :show-attributes="true"
                    :show-emoji="false"
                    v-model="clone.query"
                />
            </div>
            <div class="editor-row">
                <div class="editor-row-title">{{ $t("chatbotv2.openaiWebSearchContextSize") }}</div>
                <a-select v-model="clone.search_context_size">
                    <a-select-option value="low">{{ $t("chatbotv2.openaiWebSearchLow") }}</a-select-option>
                    <a-select-option value="medium">{{ $t("chatbotv2.openaiWebSearchMedium") }}</a-select-option>
                    <a-select-option value="high">{{ $t("chatbotv2.openaiWebSearchHigh") }}</a-select-option>
                </a-select>
            </div>
            <div class="editor-row">
                <div class="editor-row-title">{{ $t("chatbotv2.openaiIncludeDomains") }}</div>
                <div v-for="(domain, index) in clone.include_domains" :key="'domain-' + index" class="key-value-pair">
                    <a-input
                        v-model="clone.include_domains[index]"
                        :placeholder="$t('chatbotv2.openaiDomainPh')"
                        class="domain-input"
                    />
                    <a-button type="link" danger @click="removeDomain(index)">
                        <span class="material-icons">delete</span>
                    </a-button>
                </div>
                <a-button type="dashed" block @click="addDomain" class="add-btn">
                    <span class="material-icons">add</span> {{ $t("chatbotv2.openaiAddDomain") }}
                </a-button>
            </div>
        </template>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapState } from "vuex";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";

export default {
    name: "OpenaiWebSearch",
    components: { TiptapEditor, SupsisButton },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            query: "",
            search_context_size: "medium", // low, medium, high
            include_domains: ["example.com"],
        };

        // Eğer include_domains bir dizi değilse, dizi olarak ayarla
        if (!Array.isArray(clone.include_domains)) {
            clone.include_domains = ["example.com"];
        }

        return {
            clone,
        };
    },
    computed: {
        ...mapState({
            channel: (state) => state.channel.channels.find((x) => x.type === "openai"),
        }),
    },
    methods: {
        addDomain() {
            this.clone.include_domains.push("");
        },
        removeDomain(index) {
            this.clone.include_domains.splice(index, 1);
        },
        gotoOpenai() {
            this.$router.push("/integrations/openai");
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.openai-web-search {
    padding: 20px;

    .active-connection {
        align-items: center;
        background: #fff;
        border-radius: 6px;
        display: flex;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        overflow: hidden;
        padding: 20px;
        width: 100%;
        word-break: break-word;

        .logos {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            margin-right: 15px;
            margin-top: 4px;

            .logo1 {
                background: #4a6586;
            }

            .logo2 {
                background: #fff;
            }

            .logo1,
            .logo2 {
                height: 30px;
                padding: 4px;
                width: 30px;
            }
        }

        .active-connection-text {
            flex-grow: 1;
            flex-shrink: 0;
            width: 0;

            div {
                overflow: hidden !important;
                text-overflow: ellipsis;
                white-space: pre-wrap;
            }
        }
    }

    .editor-row {
        margin-bottom: 20px;

        .editor-row-title {
            font-weight: bold;
            margin-bottom: 10px;
            font-size: 16px;
        }
    }

    .key-value-pair {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;

        .domain-input {
            flex: 1;
        }

        .material-icons {
            font-size: 20px;
        }
    }

    .add-btn {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;

        .material-icons {
            font-size: 18px;
        }
    }
}
</style>
